import React, { useCallback, useState } from 'react';
import { FormularioVariablesServiciosVista } from '../../vista/formularioVariablesServiciosVista';
import { BarraCambiosSinGuardarVista } from '../../../configuracionCotizadorNbs/vista/barraCambiosSinGuardarVista';
import { configuracionServiciosInicial, variablesCompletas } from '../../interfaces';
import type { IVariablesServicios } from '../../../../modelos/CotizadorServicios/entidades/IConfiguracionServicios';
import { useNotificaciones } from '../../../../globales/contextos/notificationContext';
import { EnumTipoNotificacion } from '../../../../globales/interfaces';

const extraerVariables = ({
    TarifaHoraAscensor, TarifaHoraEscalera, HorasPorModulo, MinimoParadas, CostoPorParada, FactorEscalera,
    PorcentajeCif, PorcentajeCostosEspeciales, MargenAscensores, MargenEscaleras, PorcentajeIva,
    FactorPlanConekta, FactorPlanConektaPlus
}: IVariablesServicios): IVariablesServicios => ({
    TarifaHoraAscensor, TarifaHoraEscalera, HorasPorModulo, MinimoParadas, CostoPorParada, FactorEscalera,
    PorcentajeCif, PorcentajeCostosEspeciales, MargenAscensores, MargenEscaleras, PorcentajeIva,
    FactorPlanConekta, FactorPlanConektaPlus
});

/** Variables de la configuración: se editan juntas y se guardan con la barra de cambios sin guardar. */
export const VariablesServiciosCV: React.FC = () => {
    const { mostrarNotificacion } = useNotificaciones();
    // TODO back: consultar la configuración activa del país.
    const [variablesOriginales, setVariablesOriginales] = useState<IVariablesServicios>(() => extraerVariables(configuracionServiciosInicial));
    const [variables, setVariables] = useState<IVariablesServicios>(variablesOriginales);
    const [guardando, setGuardando] = useState(false);

    const alCambiar = useCallback((campo: keyof IVariablesServicios, valor: number | string) => {
        setVariables(prev => ({ ...prev, [campo]: valor === '' ? '' : Number(valor) }));
    }, []);

    const alGuardar = async () => {
        if (!variablesCompletas(variables)) {
            mostrarNotificacion(EnumTipoNotificacion.Warning, 'Campos Obligatorios', 'Debes diligenciar todos los campos obligatorios antes de guardar.');
            return;
        }
        setGuardando(true);
        try {
            // TODO back: guardar las variables (crea una nueva versión de la configuración).
            setVariablesOriginales(variables);
            mostrarNotificacion(EnumTipoNotificacion.Success, 'Configuración Guardada', 'Los parámetros se han actualizado correctamente.');
        } finally {
            setGuardando(false);
        }
    };

    const haCambiado = JSON.stringify(variables) !== JSON.stringify(variablesOriginales);

    return (
        <div style={{ flex: 1, paddingBottom: '20px' }}>
            <FormularioVariablesServiciosVista variables={variables} alCambiar={alCambiar} />
            <BarraCambiosSinGuardarVista
                visible={haCambiado}
                alDescartar={() => setVariables(variablesOriginales)}
                alGuardar={alGuardar}
                guardando={guardando}
            />
        </div>
    );
};
